//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uploader } from '@/utils/uploadCloud';
import i18n from '@/utils/i18n';
import helper from '@/libs/helper';
export default {
  name: 'Index',
  mixins: [i18n],
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fileTypes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    maxLength: {
      type: Number,
      default: 0
    },
    maxSize: {
      type: Number,
      default: 0
    },
    onlyImage: {
      type: Boolean,
      default: false
    },
    onlyRead: {
      type: Boolean,
      default: false
    }
  },
  components: {
    uploadList: function uploadList() {
      return import('@/components/form-common/oa-uploadList');
    }
  },
  data: function data() {
    return {
      fileList: this.value,
      percentShow: false,
      myHeaders: {
        authorization: 'Bearer ' + localStorage.getItem('token')
      },
      uploadSize: 15
    };
  },
  computed: {},
  watch: {
    value: function value(n) {
      this.fileList = n;
    }
  },
  methods: {
    clearFiles: function clearFiles() {
      this.fileList = [];
      this.$emit('input', []);
    },
    // 上传文件方法
    uploadServerLog: function uploadServerLog(params) {
      var _this = this;
      var fileTypeCheckResult = false;
      var extFileName = params.file.name.substring(params.file.name.lastIndexOf('.') + 1);
      if (this.fileTypes.length > 0) {
        fileTypeCheckResult = this.fileTypes.some(function (ft) {
          return extFileName.toLowerCase() === ft.toLowerCase();
        });
      } else {
        this.fileTypes = helper.uploadTypes;
        fileTypeCheckResult = this.fileTypes.some(function (ft) {
          return extFileName.toLowerCase() === ft.toLowerCase();
        });
      }
      if (!fileTypeCheckResult) {
        this.$message.error('不支持格式' + extFileName);
        return false;
      }
      if (this.maxSize) {
        var fileSizeCheckResult = params.file.size / 1024 / 1024 <= this.maxSize;
        if (!fileSizeCheckResult) {
          this.$message.error(this.i18nt('render.hint.fileSizeExceed') + this.maxSize + 'MB');
          return false;
        }
      }
      this.percentShow = true;
      var file = params.file;
      var onlyImg = this.onlyImage ? 1 : 0;
      var options = {
        way: 2,
        relation_type: '',
        relation_id: '',
        eid: ''
      };
      uploader(file, onlyImg, 15, options).then(function (res) {
        _this.percentShow = false;
        // 获取上传文件渲染页面
        if (res.name) {
          _this.fileList.push({
            real_name: res.name,
            size: res.size,
            name: res.name,
            url: res.url,
            id: res.id,
            file_url: res.url
          });
          _this.$emit('input', _this.fileList);
        }
      }).catch(function (err) {
        _this.percentShow = false;
      });
    },
    handleRemove: function handleRemove(file) {
      this.fileList.splice(this.fileList.findIndex(function (item) {
        return item.name === file.name;
      }), 1);
      this.$emit('input', this.fileList);
    }
  }
};